(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/calculations.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/calculations.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  _svs$numbergames$rule = _svs$numbergames.rules,
  getRules = _svs$numbergames$rule.getRules,
  systemRules = _svs$numbergames$rule.system,
  productMapping = _svs$numbergames.productMapping;

function calculateBoardRowCount(_ref) {
  let productId = _ref.productId,
    _ref$numbers = _ref.numbers,
    numbers = _ref$numbers === void 0 ? [] : _ref$numbers,
    _ref$extraNumbers = _ref.extraNumbers,
    extraNumbers = _ref$extraNumbers === void 0 ? [] : _ref$extraNumbers,
    level = _ref.level,
    isSystemBoard = _ref.isSystemBoard,
    systemSize = _ref.systemSize;
  if (isSystemBoard) {
    if (numbers.length !== (systemSize === null || systemSize === void 0 ? void 0 : systemSize.numbersSize) || extraNumbers.length !== (systemSize === null || systemSize === void 0 ? void 0 : systemSize.extraNumbersSize)) {
      return 0;
    }
  }
  const rules = getRules(productId);
  return systemRules.generatedRows({
    numbersLength: numbers.length,
    numbersExtraLength: extraNumbers.length,
    numbersRowSize: productMapping.isKeno(productId) ? level : rules.numbersMaxLength,
    numbersExtraRowSize: rules.numbersExtraMaxLength
  });
}

function calculateBoardPrice(board) {
  if (!board) return 0;
  let price = board.rowPrice;
  price *= board.rowPriceMulti;
  price *= Boolean(board.hasKungKeno) + 1;
  price *= calculateBoardRowCount(board);
  return price;
}

function calculateWagerPrice(wager) {
  if (!wager) return 0;
  let price = wager.boards.reduce((total, board) => total + calculateBoardPrice(board), 0);
  if (price) {
    var _joker$price;
    const hasLotto2 = wager.hasLotto2,
      joker = wager.joker,
      drawCount = wager.drawCount,
      products = wager.products;
    price *= Boolean(hasLotto2) + 1;
    price += (_joker$price = joker === null || joker === void 0 ? void 0 : joker.price) !== null && _joker$price !== void 0 ? _joker$price : 0;
    price *= drawCount;
    price *= products.length;
  }
  return price;
}
Object.assign(svs.numbergames.gameWager, {
  calculateWagerPrice,
  calculateBoardPrice,
  calculateBoardRowCount
});

 })(window);